<template>
  <div class="versions uk-text-left">
    <span class="uk-text-center">Click on a version number to see the project in Team City.</span>
    <ul>
      <li v-for="(dependencyObj, dependency) in versionList">
        <div class="uk-flex" v-if="dependencyObj.version.length > 0">
          <div class="uk-text-bold">{{dependencyObj.name}} :</div>
          <span @click="openTeamCityUrl(dependencyObj)" :class="{ 'span-hover' : dependencyObj.teamcityUrl }">
            {{ dependencyObj.version }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import axios from 'axios'
  import Environment from './../../plugins/environment'
  import * as clients from './../../enums/clients'
  import * as CS_SDK_BUILD_NO from './../../../static/version/cs_sdk_version.json'

  const DEVOPS_VERSION_FILENAME = '/devops_version.txt'

  export default {
    name: 'dependency-version',
    data() {
      return {
        hostName: Environment.getHostname(),
        versionList: {
          smex: {
            name: 'SMEX',
            version: Environment.getVersion(),
            testUrl: '',
            teamcityUrl: 'https://ampcity.smarttech-prod.com/project.html?projectId=ContentPortal'
          },
          suite: {
            name: 'Suite',
            version: '',
            testUrl: Environment.serviceUrlFor(clients.SLSO) + DEVOPS_VERSION_FILENAME,
            teamcityUrl: 'https://ampcity.smarttech-prod.com/project.html?projectId=Lab'
          },
          static: {
            name: 'Static',
            version: '',
            testUrl: Environment.serviceUrlFor(clients.LAB) + DEVOPS_VERSION_FILENAME,
            teamcityUrl: 'https://ampcity.smarttech-prod.com/project.html?projectId=Lab_StaticClasslabCom'
          },
          cs: {
            name: 'Content Services',
            version: '',
            testUrl: this.csResolver(Environment.getEnv()) + DEVOPS_VERSION_FILENAME,
            teamcityUrl: 'https://ampcity.smarttech-prod.com/project.html?projectId=Content_ContentServicesAwsFe&tab=projectOverview'
          },
          csSdk: {
            name: 'Content Services SDK',
            version: CS_SDK_BUILD_NO.version,
            teamcityUrl: 'https://ampcity.smarttech-prod.com/project.html?projectId=Content_ContentServicesAwsFe&tab=projectOverview'
          }
        }
      }
    },
    methods: {
      csResolver(ENV) {
        return `https://content.smarttech-${ENV}.com`
      },
      openTeamCityUrl(dependency) {
        if (dependency.teamcityUrl) {
          let win = window.open(dependency.teamcityUrl, '_blank')
          win.focus()
        }
      },
      getVersionForService(dependency) {
        if (!dependency.testUrl || dependency.version) {
          return
        }
        return axios.get(dependency.testUrl, {
          headers: {
            'Accept': 'text/plain'
          }
        }).then(response => {
          dependency.version = response.data.trim()
        }).catch(e => {
          dependency.version = dependency.version ? dependency.version : 'Unknown'
          console.warn(`Error fetching ${dependency.name} version: ` + e)
        })
      }
    },
    created() {
      for (let dependency in this.versionList) {
        this.getVersionForService(this.versionList[dependency])
      }
    }
  }
</script>

<style lang="scss" scoped>

  .versions {
    padding: 10px 20px 0 20px;

    ul {
      list-style: none;

      li {
        user-select: none;

        span {
          font-weight: normal;

          &.span-hover {
            &:hover {
              cursor: pointer;
              color: #159BD9;
            }
          }
        }
      }
    }
  }
</style>
